import React from 'react';
import {
  Container,
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardMedia,
  CardContent
} from '@mui/material';
import { routerUrls } from 'constants';
import { GlobalContext } from '../context/GlobalState';
import { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import { languages } from 'constants';
import ProductFilters from './ProductFilters';
import ScrollToTop from './ScrollToTop'; //TODO: FIX PATH
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CategorySeoBody, { CategorySeoHeader, getSeoMeta, getFaqData } from './CategorySeoContent';

// MAIN COMPONENT TO SHOW THE PRODUCT CATEGORIES BY TYPE
export default function ProductsCategories() {
  const params = useParams();
  const { lang, menu } = useContext(GlobalContext);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [currentSubCategory, setCurrentSubCategory] = useState(null);

  const { materialCategories, setMaterialCategories, categoryIdUrlParam, subcategoryIdUrlParam } =
    useContext(GlobalContext);

  useEffect(async () => {
    if (
      !materialCategories ||
      categoryIdUrlParam != params.categoryId ||
      subcategoryIdUrlParam != params.subCategoryId
    ) {
      const { data } = await axios.get(`/materialCategories?lang=bg`, {
        params
      });
      setMaterialCategories(data);
      // logic to get the selected category and subcategory path e.g. bed linen > sheets
    }
    if (languages.bg === lang) {
      let category = menu.find((categ) => {
        return categ.id === parseInt(params.categoryId);
      });
      setCurrentCategory(category);
      let subCategory = category.subCategories.find((subCat) => {
        return subCat.id === parseInt(params.subCategoryId);
      });
      setCurrentSubCategory(subCategory);
    }
  }, [params, menu]);

  const curatedImagesPerCategory = {
    // bed sheets
    1: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/kat/bed11.jpg', //SATEN
      'https://gotobed.eu/wp-content/uploads/files/kat/bed7.jpg' //RANFORCE
    ],
    // pillows
    2: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/kat/bed.jpg',
      'https://gotobed.eu/wp-content/uploads/files/kat/bed2.jpg'
    ],
    // fitted sheets
    3: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/kat/bed3.jpg',
      'https://gotobed.eu/wp-content/uploads/files/kat/bed4.jpg'
    ],
    // duvet cases
    4: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/kat/bed9.jpg',
      'https://gotobed.eu/wp-content/uploads/files/kat/bed6.jpg'
    ],
    // no 5th category !!!
    5: [
      '', //because subcategories start from 1 :)
      '',
      ''
    ],
    // round fitted sheets
    6: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/kat/round.jpg',
      'https://gotobed.eu/wp-content/uploads/files/kat/round3.jpg'
    ],
    // kids sheets
    7: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/admin/R-184-8.jpg',
      'https://gotobed.eu/wp-content/uploads/files/admin/R-172-6.jpg'
    ],
    // kids pillowcases
    8: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/admin/R-148-6.jpg',
      'https://gotobed.eu/wp-content/uploads/files/admin/R-179-4.jpg'
    ],
    // kids fitted sheets
    9: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/admin/R-185-6.jpg',
      'https://gotobed.eu/wp-content/uploads/files/admin/R-176-5.jpg'
    ],
    // kids duvet covers
    10: [
      '', //because subcategories start from 1 :)
      'https://gotobed.eu/wp-content/uploads/files/admin/R-173-4.jpg',
      'https://gotobed.eu/wp-content/uploads/files/admin/R-191-5-1.jpg'
    ]
  };

  return (
    <ScrollToTop>
      {currentSubCategory && (
        <Helmet>
          <title>
            {getSeoMeta(params.categoryId, params.subCategoryId)?.title ||
              `Продукти за ${currentSubCategory.name_bg}. Размери по поръчка`}
          </title>
          <meta
            name="description"
            content="спално бельо, чаршаф, плик, калъфка, чаршаф с ластик, кръгъл чаршаф с ластик, бебешко, детско спално бельо, памучен сатен, ранфорс, памук"
          />
          <link rel="canonical" href={window.location.href} />
          {getFaqData(params.categoryId, params.subCategoryId) && (
            <script type="application/ld+json">
              {JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: getFaqData(params.categoryId, params.subCategoryId).map((faq) => ({
                  '@type': 'Question',
                  name: faq.q,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.a
                  }
                }))
              })}
            </script>
          )}
        </Helmet>
      )}
      <Container
        maxWidth="xl"
        sx={{
          backgroundColor: '',
          paddingTop: 0,
          justifyContent: 'center',
          margin: 0,
          paddingBottom: '40px',
          minHeight: 400
        }}>
        <Grid container justifyContent="center" spacing={4}>
          <Grid item lg={3} md={4} xs={12}>
            <ProductFilters />
          </Grid>

          <Grid item lg={9} md={8} xs={12}>
            <CategorySeoHeader
              categoryId={params.categoryId}
              subCategoryId={params.subCategoryId}
            />
            {!getSeoMeta(params.categoryId, params.subCategoryId) && (
              <Typography variant="h5" sx={{ mb: 1, color: 'text.primary' }}>
                {currentCategory && currentSubCategory && currentSubCategory.name_bg}
              </Typography>
            )}
            <Typography variant="subtitle1" sx={{ mb: 3, color: 'text.secondary' }}>
              Разгледайте Продукти по Материали
            </Typography>
            <Grid container spacing={4}>
              {currentCategory &&
                currentSubCategory &&
                materialCategories &&
                [...materialCategories].reverse().map(
                  (item) =>
                    item.count > 0 && (
                      <Grid item key={item.id} lg={4} md={6} xs={12}>
                        <Card
                          sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: 'none',
                            borderRadius: 2,
                            overflow: 'hidden',
                            transition: 'transform 0.25s ease, border-color 0.25s ease',
                            '&:hover': {
                              transform: 'translateY(-4px)',
                              borderColor: 'hairline.strong'
                            }
                          }}>
                          <CardActionArea
                            component={Link}
                            to={
                              routerUrls.products +
                              '/' +
                              currentCategory.slug_bg +
                              '/' +
                              currentSubCategory.slug_bg +
                              '/' +
                              params.categoryId +
                              '/' +
                              params.subCategoryId +
                              '/' +
                              item.id
                            }
                            sx={{ height: '100%' }}>
                            <CardMedia
                              component="img"
                              height="340"
                              image={
                                curatedImagesPerCategory[params.subCategoryId]?.[item.id] ||
                                'https://gotobed.eu/wp-content/uploads/2023/11/placeholder.jpg'
                              }
                              alt={item.name_bg}
                              sx={{
                                objectFit: 'cover',
                                transition: 'transform 0.4s ease',
                                '&:hover': {
                                  transform: 'scale(1.05)'
                                }
                              }}
                            />
                            <CardContent>
                              <Typography variant="h6" fontWeight={600} gutterBottom>
                                {item.name_bg}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                {item.count} продукта
                              </Typography>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Grid>
                    )
                )}
            </Grid>
            <CategorySeoBody categoryId={params.categoryId} subCategoryId={params.subCategoryId} />
          </Grid>
        </Grid>
      </Container>
    </ScrollToTop>
  );
}
